export default "__VITE_ASSET__CVG4YDFQ__"